import { React } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid, ListItem, Paper, Tooltip } from '@material-ui/core';
import { GetApp as DownloadIcon } from '@material-ui/icons';
import PostAddIcon from '@material-ui/icons/PostAdd';
import EditIcon from '@material-ui/icons/Edit';
import { BsFileEarmarkBarGraphFill } from "react-icons/bs";
import { ACCESS_TOKEN } from '../../app/api-client/constants';


const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-3%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));


export default function ListPolls({ rows, isLoadUser, handledEditPoll, primaryColor }) {
  const clases = useStyles()
  const history = useHistory();

  const handleRowClick = (row) => {
    history.push(`/polls/preguntas/${row.id}`);
  }
  const handleResults = (row) => {
    let parametros = {
      Encuesta: row.name,
    };
    history.push(`/polls/results/${row.id}`, parametros);
  }
  
  const handleDownload = async (row) => {
    try {
      const token = localStorage.getItem(ACCESS_TOKEN);
      const response = await fetch(`${process.env.REACT_APP_API_POLL}/v2/poll/export/excel/${row.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error('Error al descargar el archivo');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Resultados ${row.name}.xls`; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar:', error);
    }
  };

  return (
    <>
      {rows.map((row) => (
        <Paper className={clases.card} key={row.id}>
          <Grid container spacing={1}>
            <Grid item style={{ width: '20%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
              {row.id}
            </Grid>
            <Grid item style={{ width: '22%', paddingLeft: '0%', fontWeight: 'bold', fontSize: '16px' }}>
              {row.name}
            </Grid>
            <Grid style={{ width: '30%', paddingLeft: '1%', fontWeight: 'bold', fontSize: '16px' }}>
              {row.description}
            </Grid>
            <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => handleRowClick(row)} className={clases.actionsStyles}>
              <ListItem button >
                <Tooltip title="Preguntas" aria-label="top-end">
                  <PostAddIcon className={clases.tableAction} style={{ color: primaryColor }} />
                </Tooltip>
              </ListItem>
            </Grid>
            <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => handledEditPoll(row)} className={clases.actionsStyles}>
              <ListItem button >
                <Tooltip title="Editar" aria-label="top-end">
                  <EditIcon className={clases.tableAction} style={{ color: primaryColor }} />
                </Tooltip>
              </ListItem>
            </Grid>
            <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => handleDownload(row)} className={clases.actionsStyles}>
              <ListItem button >
                <Tooltip title="Descargar" aria-label="top-end">
                  <DownloadIcon className={clases.tableAction} style={{ color: primaryColor }} />
                </Tooltip>
              </ListItem>
            </Grid>
            <Grid item xs={1} style={{ width: '5%', paddingLeft: '0%' }} onClick={() => handleResults(row)} className={clases.actionsStyles}>
              <ListItem button >
                <Tooltip title="Resultados" aria-label="top-end">
                  <BsFileEarmarkBarGraphFill className={clases.tableAction} style={{ color: primaryColor, fontSize: '22px', display: 'none' }} />
                </Tooltip>
              </ListItem>
            </Grid>
          </Grid>
        </Paper>
      ))}
      {isLoadUser && (
        <Paper className={clases.card}>
          <CircularProgress style={{ marginLeft: '60%' }} />
        </Paper>
      )}
    </>
  )
}
